export { Chains, WalletConnectorBase, socialProviders } from './lib/WalletConnector.js';
export { logger } from './utils/logger.js';
export { ProviderLookup } from './utils/ProviderLookup/ProviderLookup.js';
export { getChainInfo } from './utils/getChainInfo/getChainInfo.js';
export { isEmailOTPWalletConnector } from './utils/isEmailOTPWalletConnector/isEmailOTPWalletConnector.js';
export { isEmailWalletConnector } from './utils/isEmailWalletConnector/isEmailWalletConnector.js';
export { isSameAddress } from './utils/isSameAddress/isSameAddress.js';
export { isSocialWalletConnector } from './utils/isSocialWalletConnector/isSocialWalletConnector.js';
export { addHexPrefix, bufferToHex, utf8ToHex } from './utils/encoding.js';
export { getWalletConnectorByName } from './utils/getWalletConnectorByName.js';
export { shouldLowercaseAddress } from './utils/shouldLowercaseAddress.js';
export { normalizeWalletName } from './utils/normalizeWalletName/normalizeWalletName.js';
export { PhantomLedgerWalletName } from './utils/PhantomLedgerWalletName.js';
export { getDeepLink } from './utils/walletConnectDeepLinks/walletConnectDeepLinks.js';
export { performPlatformSpecificConnectionMethod } from './utils/walletConnectDeepLinks/performPlatformSpecificConnectionMethod.js';
export { isEmbeddedConnector } from './utils/isEmbeddedConnector/isEmbeddedConnector.js';
export { isMagicConnector } from './utils/isMagicConnector/isMagicConnector.js';
export { isBloctoConnector } from './utils/isBloctoConnector/isBloctoConnector.js';
